import { Reducer } from "redux";
import { DropdownItemProps } from "semantic-ui-react";

export const SET_VERTICES_LIMITS = "SET_VERTICES_LIMITS";
export const ADD_VERTEX_LIMITS = "ADD_VERTEX_LIMITS";
export const SET_SELECTED_VERTEX_FILTERING_TYPE = "SET_SELECTED_VERTEX_FILTERING_TYPE";
export const SET_AHC = "SET_AHC";

export const SetVerticesLimits = (nps: IVerticesFiltering[]) => {
    return { type: SET_VERTICES_LIMITS, nps };
};
export const AddVertexLimits = (np: IVerticesFiltering) => {
    return { type: ADD_VERTEX_LIMITS, np };
};

export const SetSelectedVertexFilteringType = (option: number) => {
    return { type: SET_SELECTED_VERTEX_FILTERING_TYPE, option };
};

export const SetAhc = (option: boolean) => {
    return { type: SET_AHC, option };
};

export enum VertexFilteringType {
    FilterVertices = 0,
    ReduceVerticesToLimits = 1,
}

export const vertexFilteringTypeDropdownItems: DropdownItemProps[] = [
    { key: VertexFilteringType.FilterVertices, text: 'Filter Vertices', value: VertexFilteringType.FilterVertices },
    { key: VertexFilteringType.ReduceVerticesToLimits, text: 'Reduce Vertices To Limits', value: VertexFilteringType.ReduceVerticesToLimits },
];
export interface IValue {
    [key: string]: IVerticesFilteringElem;
}

export interface IVerticesFilteringElem extends Record<string, number | string | boolean | undefined> {
    key?: string;
    minValue: number;
    maxValue: number;
    ahc?: boolean;
    disabled?: boolean;
}

export interface IVerticesFiltering {
    hour: number;
    values: IValue;
}

export const verticesFilteringInit: IVerticesFiltering = {
    hour: -1,
    values: {
        at: { minValue: -99999, maxValue: 99999 },
        be: { minValue: -99999, maxValue: 99999 },
        be_al: { minValue: -99999, maxValue: 99999 },
        cz: { minValue: -99999, maxValue: 99999 },
        de: { minValue: -99999, maxValue: 99999 },
        de_al: { minValue: -99999, maxValue: 99999 },
        fr: { minValue: -99999, maxValue: 99999 },
        hr: { minValue: -99999, maxValue: 99999 },
        hu: { minValue: -99999, maxValue: 99999 },
        nl: { minValue: -99999, maxValue: 99999 },
        pl: { minValue: -99999, maxValue: 99999 },
        ro: { minValue: -99999, maxValue: 99999 },
        si: { minValue: -99999, maxValue: 99999 },
        sk: { minValue: -99999, maxValue: 99999 },
        RO_BG_VH: { minValue: -99999, maxValue: 99999, ahc: true },
        DE_DK2_BigHub: { minValue: -99999, maxValue: 99999, ahc: true },
        PL_LT_BigHub: { minValue: -99999, maxValue: 99999, ahc: true },
        DE_NO2_BigHub: { minValue: -99999, maxValue: 99999, ahc: true },
        DE_DK1_VH: { minValue: -99999, maxValue: 99999, ahc: true },
        NL_DK1_COBRA: { minValue: -99999, maxValue: 99999, ahc: true },
        NL_NO2_NorNed: { minValue: -99999, maxValue: 99999, ahc: true },
        DE_SE4_Baltic: { minValue: -99999, maxValue: 99999, ahc: true },
        PL_SE4_SwePol: { minValue: -99999, maxValue: 99999, ahc: true },
    },
};

export interface VerticesFilteringState {
    verticesLimits: IVerticesFiltering[];
    vertexFilteringType: VertexFilteringType;
    ahc: boolean;
}

const initialState: VerticesFilteringState = {
    verticesLimits: [],
    vertexFilteringType: VertexFilteringType.FilterVertices,
    ahc: false,
};

export const verticesFilteringReducer: Reducer<VerticesFilteringState> = (
    state: VerticesFilteringState = initialState,
    action: any
): VerticesFilteringState => {
    switch (action.type) {
        case SET_VERTICES_LIMITS:
            return { ...state, verticesLimits: action.nps };
        case ADD_VERTEX_LIMITS:
            if (state.verticesLimits.some(x => x.hour === action.np.hour)) {
                const newVerticesLimits = state.verticesLimits.filter(x => x.hour !== action.np.hour);
                return { ...state, verticesLimits: newVerticesLimits.concat(action.np) };
            } else return { ...state, verticesLimits: state.verticesLimits.concat(action.np) };
        case SET_SELECTED_VERTEX_FILTERING_TYPE:
            return { ...state, vertexFilteringType: action.option };
        case SET_AHC:
            return { ...state, ahc: action.option };
        default:
            return state;
    }
};
